import { RadioGroup } from "@radix-ui/react-radio-group";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import { RadioGroupItem } from "src/core/components/ui/radio-group";
import { RISK_LEVEL_CLASSES } from "src/core/constants/risk";
import { useQuestionnaireForm } from "src/core/hooks/folder/useQuestionnaireForm";

export const FolderQuestionnaireLAB: React.FC<{ isOnePage?: boolean }> = ({
  isOnePage = false,
}) => {
  const { t } = useTranslation();
  const { questionnaireLAB, control, handleSubmit, onSubmit, isLoading, message, isReadOnly } =
    useQuestionnaireForm();

  return (
    <div className="folder-questionnaire-wrapper">
      {!isOnePage && (
        <div className="folder-tab-banner">
          <div className="section-title">{t("folder.questionnaire.title")}</div>
        </div>
      )}
      <div
        className={isOnePage ? "folder-questionnaire-data-one-page" : "folder-questionnaire-data"}
      >
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          {questionnaireLAB &&
            questionnaireLAB.questions.map((question) => (
              <div key={question.code} className="grid grid-cols-8 my-20 items-center gap-x-30">
                <div className="flex flex-row items-center col-span-6 gap-x-10">
                  <div
                    className={`min-w-[16px] h-[16px] rounded-full ${
                      question.answer === true
                        ? RISK_LEVEL_CLASSES.HIGH
                        : question.answer === false
                        ? RISK_LEVEL_CLASSES.LOW
                        : RISK_LEVEL_CLASSES.UNDEFINED
                    }`}
                  />
                  <div>{question.libelle}</div>
                </div>

                <Controller
                  name={question.code}
                  control={control}
                  render={({ field }) => (
                    <RadioGroup
                      value={
                        field.value === true
                          ? "true"
                          : field.value === false
                          ? "false"
                          : "undefined"
                      }
                      onValueChange={(val) => {
                        field.onChange(val === "true" ? true : val === "false" ? false : undefined);
                      }}
                      className="grid grid-cols-2 gap-x-20 col-span-2"
                    >
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem
                          value="true"
                          id={`${question.code}-oui`}
                          disabled={isReadOnly}
                        />
                        <label htmlFor={`${question.code}-oui`} className="text-sm">
                          {t("folder.questionnaire.yes")}
                        </label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem
                          value="false"
                          id={`${question.code}-non`}
                          disabled={isReadOnly}
                        />
                        <label htmlFor={`${question.code}-non`} className="text-sm">
                          {t("folder.questionnaire.no")}
                        </label>
                      </div>
                    </RadioGroup>
                  )}
                />
              </div>
            ))}
          {!isReadOnly && (
            <div className="flex flex-col items-end justify-end">
              {message && (
                <div className="text-primary mb-10">
                  {t("folder.questionnaire.missingQuestions")}
                </div>
              )}
              <Button type="submit" className="w-[150px] mb-5" loading={isLoading}>
                {t("folder.questionnaire.save")}
              </Button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};
